import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import type { OnlineShareChannel } from 'src/app/pages/starterDashboardV2/shared/types';
import { ShareButton } from 'src/app/shared/components/ShareButton';
import type { ShareAction } from 'src/app/shared/hooks/share';

import { SHARE_BUTTON_CONFIG } from '../../../useDashboardShareActions/constants';

type OnlineShareAction = ShareAction & { channel: OnlineShareChannel };
type Props = { actions: readonly OnlineShareAction[] };
export function ActionItems({ actions }: Props): JSX.Element {
	return (
		<Box as="ul" role="list" sx={{ display: 'grid', gridGap: 12, mt: 24, gridTemplateColumns: '1fr 1fr' }}>
			{actions.map(({ action, channel }, index) => {
				const { label, successLabel } = SHARE_BUTTON_CONFIG[channel];

				return (
					<Box
						key={channel}
						as="li"
						role="listitem"
						data-qa={`sfs-${channel}-button`}
						sx={{ gridColumn: index === 0 ? 'span 2' : undefined }}
					>
						<ShareButton channel={channel} action={action} label={label} successLabel={successLabel} />
					</Box>
				);
			})}
		</Box>
	);
}
